export default "__VITE_ASSET__2479d696__"